// extracted by extract-css-chunks-webpack-plugin
module.exports = {"platform-copyright":"platform-copyright_1lJb1","platform-copyright__link":"platform-copyright__link_2Yr6x","platform-copyright__logo":"platform-copyright__logo_3MUdN"};